import { render, staticRenderFns } from "./AbastecimentoCreate.vue?vue&type=template&id=002cd4e7&"
import script from "./AbastecimentoCreate.vue?vue&type=script&lang=js&"
export * from "./AbastecimentoCreate.vue?vue&type=script&lang=js&"
import style0 from "./AbastecimentoCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports